export default __webpack_public_path__ + "static/media/callraise_0007_thumb.0c403d9a.jpg";